import React, { useEffect } from "react";

function BankSelection({ bankDeatils, checkValue, setStoreBankDetail, loading = false }) {
  useEffect(() => {
    if (checkValue) {
      setStoreBankDetail(bankDeatils);
    }
  }, [checkValue]);



  return (
    <div className="valign-wrapper space-between " style={{ padding: " 1rem" }}>
      <span className="valign-wrapper gap-1">
        <span className="material-icons-outlined">account_balance</span>
        <div>
          <span className="valign-wrapper" style={{ gap: "5px" }}>
            <span>
              {bankDeatils?.bankName} -{" "}
              {String(bankDeatils?.accountNo).slice(-5)}
            </span>
            <img src={`${process.env.PUBLIC_URL}/icons/Icon.svg`} alt="Icon" />
          </span>
          <p
            className="grey-text"
            style={{ marginTop: "-5px", fontSize: "14px" }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/icons/green-circle.svg`}
              alt="green"
              style={{ paddingRight: "5px" }}
            />
            Verified
          </p>
        </div>
      </span>
      {checkValue ? (
        <span className="material-icons-outlined mr-1 cercle-purple-text pointer">
          check_circle
        </span>
      ) : (
        <span className="material-icons-outlined pointer mr-1">circle</span>
      )}
    </div>
  );
}

export default BankSelection;
